import { Layout } from '@/components/Common';
import CustomHead from '@/components/Common/Layout/Head';
import { WEBSITE_URL } from '@/shared/constants';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { StructuredDataAuthorProps, StructuredDataType } from '@/shared/types/structured-data';
import { ReactElement } from 'react';

interface IProps {
  title: string;
  description: string;
  path?: string;
  image: string;
  hideFooter?: boolean;
  structuredDataType?: StructuredDataType;
  author?: StructuredDataAuthorProps[];
  datePublished?: string;
  dateModified?: string;
}

export const getPageLayout = ({
  title,
  description,
  path,
  image,
  hideFooter = true,
  structuredDataType,
  author,
  datePublished,
  dateModified,
}: IProps) => {
  return (page: ReactElement) => {
    if (path === void 0 && page.props?.context?.resolvedUrl) {
      path = page.props?.context?.resolvedUrl.slice(1);
    }

    return (
      <>
        <CustomHead
          title={title}
          description={description}
          url={`${WEBSITE_URL}${path?.charAt(0) === '/' ? path : '/' + path}`}
          image={image}
          structuredDataType={structuredDataType}
          author={author}
          datePublished={datePublished}
          dateModified={dateModified}
        />
        <Layout
          structured={SEO_META[SEO_META_PAGES.IDEATION].jsonld({
            url: typeof window === 'object' ? window.location.href : '',
          })}
          hideFooter={hideFooter}
        >
          {page}
        </Layout>
      </>
    );
  };
};
